import React from "react";

export const Spacer = () => {
  return <div className="my-2" />;
};
